import * as React from "react";
import { Subscription } from "rxjs";
import { WithStyles, withStyles, createStyles, Theme } from '../mui/styles';
import IconButton from '@material-ui/core/IconButton';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import CloseIcon from '@material-ui/icons/Close';
import DoneIcon from '@material-ui/icons/Done';
import ErrorIcon from '@material-ui/icons/Error';
import LinearProgress from '@material-ui/core/LinearProgress';
import Typography from '@material-ui/core/Typography';
import { FileInfo } from "./FileInfo";


export interface UploadFilesListItemProps {
    fileInfo: FileInfo;
    removeFile: (index: FileInfo) => void;
    allowedExtensions: string[];
}

type PropsType = UploadFilesListItemProps & WithStyles<typeof styles>;

class UploadFilesListItem extends React.PureComponent<PropsType> {


    private uploadSubscr: Subscription;

    componentDidMount() {
        const { fileInfo, allowedExtensions } = this.props;

        this.uploadSubscr = fileInfo.upload.subscribe((fi) => {
            switch (fi.state) {
                case 'done':
                    fileInfo.progress = 100;
                    fileInfo.uploading = false;
                    fileInfo.uploaded = true;
                    this.forceUpdate();
                    break;
                case 'progress':
                    fileInfo.progress = fi.percentage;
                    fileInfo.uploading = true;
                    fileInfo.uploaded = false;
                    fileInfo.hasError = false;
                    this.forceUpdate();
                    break;
                case 'error':
                    fileInfo.progress = 0;
                    fileInfo.uploading = false;
                    fileInfo.uploaded = false;
                    fileInfo.hasError = true;
                    fileInfo.errorMessage = fi.httpStatusCode === 415 ? 'Soubor byl odmítnut. Přesvědčte se, že formát souboru je správný (' + allowedExtensions.join(', ') + ').' : 'Soubor se nepodařilo odeslat.';
                    this.forceUpdate();
                    break;
            }
        });
    }

    componentWillUnmount() {
        if (this.uploadSubscr !== undefined) {
            this.uploadSubscr.unsubscribe();
            this.uploadSubscr = undefined;
        }
    }

    render() {
        const { fileInfo, removeFile, classes } = this.props;
        const { progress, uploading, uploaded, hasError, errorMessage } = fileInfo;
        const width = uploading ? 80 : 25;
        const align = uploading ? 'left' : 'right';

        return <TableRow hover>
            <TableCell>
                <Typography variant="subtitle1">{fileInfo.file.name}</Typography>
                {hasError ? <Typography variant="caption" color="error">{errorMessage}</Typography> : null}
            </TableCell>
            <TableCell width={width} align={align}>{
                uploading
                    ? <LinearProgress variant="determinate" value={progress} />
                    : uploaded ? <DoneIcon className={classes.done} /> : hasError ? <ErrorIcon color="error" /> : null}
            </TableCell>

            <TableCell align="right" width={25}>
                <IconButton color="secondary" onClick={() => removeFile(fileInfo)}><CloseIcon fontSize="small" /></IconButton>
            </TableCell>
        </TableRow>;
    }
}


const styles = (theme: Theme) => createStyles({
    error: {
        color: 'red',
    },
    done: {
        color: theme.palette.success.main,
    }
});

export default withStyles(styles)(UploadFilesListItem);